import { Box, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const Loader: React.FC<{ rows?: number }> = ({ rows = 8 }) => {
    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell padding="checkbox">
                            <Skeleton variant="rectangular" width={18} height={18} />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width={120} />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width={100} />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width={200} />
                        </TableCell>
                        <TableCell align="right">
                            <Skeleton variant="text" width={80} />
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {[...Array(rows)].map((_, index) => (
                        <TableRow key={index}>
                            <TableCell padding="checkbox">
                                <Skeleton variant="rectangular" width={18} height={18} />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width={150} />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width={120} />
                            </TableCell>
                            <TableCell>
                                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                    <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: '16px' }} />
                                    <Skeleton variant="rectangular" width={100} height={24} sx={{ borderRadius: '16px' }} />
                                    <Skeleton variant="rectangular" width={90} height={24} sx={{ borderRadius: '16px' }} />
                                </Box>
                            </TableCell>
                            <TableCell align="right">
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Skeleton variant="rectangular" width={24} height={24} />
                                    <Skeleton variant="rectangular" width={24} height={24} />
                                </Box>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default Loader;
